import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-permission-management',
  templateUrl: './permission-management.component.html',
  styleUrls: ['./permission-management.component.scss']
})
export class PermissionManagementComponent implements OnInit {

  constructor() {

  }

  ngOnInit(): void {
    
  }

}
